export default "__VITE_ASSET__caae0a7b__"